import { Button, Form, Switch, Radio, InputNumber, Spin, message } from 'antd';
import React, { useEffect } from 'react';
import { InfraredRayCommand } from '../../Device/Simulator/InfraredRay';

export const AirConditionerConfig = (props) => {
    const [form] = Form.useForm();
    const { masterDevice, device, onClose } = props;
    const [state, setState] = React.useState(null);

    // 发送查询指令到空调获取当前的状态
    useEffect(() => {
        try {
            masterDevice.sendInfraredRayCommand(InfraredRayCommand.AirConditionerQuery, null, (data) => {
                setState(data);
            });
        }  catch(e) {
            console.error(e);
            message.error(e.message);
            onClose();
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [masterDevice, device]);

    if(!state) {
        return <Spin />
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '10px'
        }}>
            <Form
                form={form}
                name="basic"
                layout="horizontal"
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 24 }}
                style={{ width: '100%' }}
                initialValues={state}
                onFinish={(values) => {
                    masterDevice.sendInfraredRayCommand(InfraredRayCommand.AirConditionerSetting, values);
                    onClose();
                }}
            >
                <Form.Item
                    label="开关"
                    name="power"
                    valuePropName="checked"
                    rules={[{ required: false }]}
                >
                    <Switch style={{ display: 'flex' }} />
                </Form.Item>
            
                <Form.Item
                    label="模式"
                    name="mode"
                    rules={[{ required: false }]}
                >
                    <Radio.Group style={{ display: 'flex' }}>
                        <Radio value="制冷">制冷</Radio>
                        <Radio value="制热">制热</Radio>
                        <Radio value="送风">送风</Radio>
                        <Radio value="除湿">除湿</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    label="温度"
                    name="temperature"
                    rules={[{ required: false }]}
                >
                    <InputNumber min={16} max={30} style={{ display: 'flex' }} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">确定</Button>
                </Form.Item>
            </Form>
        </div>
    );
};
